import axios from '../axiosInstances/axiosInstance';

export const referralHistory = () => {
  return axios.get(`/users/referrals`);
};
